import * as echarts from 'echarts';
export default {
  name: "NumBarChart",
  props: {
    data: {
      type: Array,
      default: () => {
        return [20];
      }
    },
    total: {
      type: Number,
      default: 0
    }
  },
  watch: {
    data() {
      this.$nextTick(() => this.render());
    }
  },
  methods: {
    render() {
      let option = {
        title: {
          text: '正确数量',
          subtext: '综合你的当前成绩、历史成绩及平台历史做题成绩'
        },
        tooltip: {
          trigger: 'axis',
          formatter: function (params) {
            console.log(params);
            return '<div><span style="color:#FF5733">录取最高正确数量：' + params[0]?.data?.max + '</span> </div>' + '<div><span style="color:#FFD700">录取最低正确数量：' + params[0]?.data?.min + '</span> </div>' + '<div><span style="color:#77DD77">' + params[0]?.data?.name + '数量：' + params[0]?.data?.value + '</span></div>';
          }
        },
        legend: {
          bottom: 'bottom',
          left: 'center',
          itemStyle: {
            color: '#3269FF'
          }
        },
        xAxis: [{
          type: 'category',
          // prettier-ignore
          data: ['本次正确', '历史正确', '平台正确']
        }],
        yAxis: [{
          type: 'value',
          min: 0,
          max: this.total
        }],
        series: [{
          name: '正确数量',
          type: 'bar',
          data: [{
            value: this.data[0],
            name: '当前正确',
            itemStyle: {
              color: '#3269FF'
            },
            max: this.total,
            min: this.total * 0.7
          }, {
            value: this.data[1],
            name: '历史正确',
            itemStyle: {
              color: '#3269FF'
            },
            max: this.total,
            min: this.total * 0.7
          }, {
            value: this.data[2],
            name: '平台正确',
            itemStyle: {
              color: '#3269FF'
            },
            max: this.total,
            min: this.total * 0.7
          }],
          markLine: {
            data: [{
              name: '通过率最高水平线',
              yAxis: this.total,
              itemStyle: {
                color: '#FF5733'
              }
            }, {
              name: '通过率最低水平线',
              yAxis: this.total * 0.7,
              itemStyle: {
                color: '#FFD700'
              }
            }]
          },
          label: {
            show: true,
            // 显示标签
            position: 'inside',
            formatter: '{c}',
            textStyle: {
              color: 'black'
            }
          }
        }]
      };
      let pie = document.getElementById('numBarChart');
      let exist = echarts.getInstanceByDom(pie);
      if (exist) {
        console.log(this.id, '销毁已存在的');
        exist.dispose();
      }
      let chart = echarts.init(pie);
      chart.setOption(option);
    },
    init() {
      this.$nextTick(() => this.render());
    }
  },
  mounted() {
    this.init();
  }
};